function weboostClickMore() {
  const moreTextSection = document.getElementById("weboost-moretext-section");
  const button = document.getElementById("weboost-moreless-button-id");

  if (moreTextSection.classList.contains("weboost-toggle-display")) {
    moreTextSection.classList.remove("weboost-toggle-display");
    button.textContent = "Read less";
  } else {
    moreTextSection.classList.add("weboost-toggle-display");
    button.textContent = "Read more";
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // FAQ功能
  const questions = document.querySelectorAll(".faq-question");
  questions.forEach((question) => {
    question.addEventListener("click", () => {
      question.classList.toggle("active");
      const answer = question.nextElementSibling;
      answer.classList.toggle("show");
    });
  });
});




// (function () {
//   if (window.__TS_HOOKED__) return;
//   window.__TS_HOOKED__ = true;

//   const show = (label, url) => {
//     console.groupCollapsed('[URL change]', label, url);
//     console.trace();
//     console.groupEnd();
//     debugger; // 命中后在 DevTools 会停住
//   };

//   // History API
//   const _ps = history.pushState.bind(history);
//   history.pushState = function(...a){ show('history.pushState', location.href); return _ps(...a); };

//   const _rs = history.replaceState.bind(history);
//   history.replaceState = function(...a){ show('history.replaceState', location.href); return _rs(...a); };

//   // location.assign / replace
//   const _assign = location.assign.bind(location);
//   location.assign = function(u){ show('location.assign', u); return _assign(u); };

//   const _replace = location.replace.bind(location);
//   location.replace = function(u){ show('location.replace', u); return _replace(u); };

//   // 拦截 location.href 直接赋值
//   try {
//     const d = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
//     if (d && d.set) {
//       Object.defineProperty(Location.prototype, 'href', {
//         set(v){ show('location.href =', v); return d.set.call(this, v); },
//         get(){ return d.get.call(this); }
//       });
//     }
//   } catch(e) {}
// })();

